function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import Modal from 'src/Components/Modal';
import Button from '../../Components/Button';
import icClose from 'assets/svg/ic_close_2.svg';
import icSuccess from 'assets/img/ic_success.png';
import { useTestId } from '@wolffun/testable-id';

const TransactionSuccessModal = ({
  onClose
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", _extends({
    className: styles.modal
  }, generateTestIdProps('request-handle-modal')), /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icSuccess,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Your request will be handled soon!"), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "You can view your activity from the History section of the Profile page after the process has finished."), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    title: "I understand"
  })))));
};

export default TransactionSuccessModal;